import { z } from 'zod';
import { apropriacaoEntradaSchema, type ApropriacaoResponse } from './custos-pessoas.js';
import { cuid, paginacao } from './primitives.js';

/** Sessao 16 (item 2): contas contabeis do cliente e itens de CIF recorrentes (sem importacao; a API do ERP vem depois). */

// ---------- Contas contabeis ----------

const codigoConta = z.string().trim().min(1, 'Informe o código').max(40);
const descricaoConta = z.string().trim().min(1, 'Informe a descrição').max(200);
export const criarContaContabilSchema = z.object({ codigo: codigoConta, descricao: descricaoConta });
export type CriarContaContabilDto = z.infer<typeof criarContaContabilSchema>;
export const atualizarContaContabilSchema = z
  .object({ codigo: codigoConta, descricao: descricaoConta, ativo: z.boolean() })
  .partial()
  .refine((v) => Object.keys(v).length > 0, 'Informe ao menos um campo');
export type AtualizarContaContabilDto = z.infer<typeof atualizarContaContabilSchema>;
export const listarContasContabeisSchema = paginacao.extend({
  q: z.string().trim().min(1).max(100).optional(),
  ativo: z.enum(['true', 'false']).transform((v) => v === 'true').optional(),
});
export type ListarContasContabeisQuery = z.infer<typeof listarContasContabeisSchema>;
export interface ContaContabilResponse {
  id: string;
  codigo: string;
  descricao: string;
  ativo: boolean;
}

// ---------- Itens de CIF ----------

const nomeItem = z.string().trim().min(1, 'Informe o nome').max(120);
/** `centroId` = atalho "vai direto para este centro" (MANUAL 100%); vale no lugar de `apropriacao`. */
export const criarItemCifSchema = z
  .object({
    nome: nomeItem,
    contaIds: z.array(cuid).max(50).default([]),
    apropriacao: apropriacaoEntradaSchema.optional(),
    centroId: cuid.optional(),
  })
  .refine((v) => !(v.apropriacao && v.centroId), { message: 'Informe a apropriação ou o centro, não os dois', path: ['centroId'] });
export type CriarItemCifDto = z.infer<typeof criarItemCifSchema>;
export const atualizarItemCifSchema = z
  .object({
    nome: nomeItem,
    ativo: z.boolean(),
    contaIds: z.array(cuid).max(50),
    apropriacao: apropriacaoEntradaSchema.nullable(),
    centroId: cuid,
  })
  .partial()
  .refine((v) => Object.keys(v).length > 0, 'Informe ao menos um campo')
  .refine((v) => !(v.apropriacao && v.centroId), { message: 'Informe a apropriação ou o centro, não os dois', path: ['centroId'] });
export type AtualizarItemCifDto = z.infer<typeof atualizarItemCifSchema>;
export const listarItensCifSchema = paginacao.extend({
  q: z.string().trim().min(1).max(100).optional(),
  ativo: z.enum(['true', 'false']).transform((v) => v === 'true').optional(),
});
export type ListarItensCifQuery = z.infer<typeof listarItensCifSchema>;
export interface ItemCifResponse {
  id: string;
  nome: string;
  ativo: boolean;
  contas: ContaContabilResponse[];
  apropriacao: ApropriacaoResponse | null;
}
